import { getPanelStyles } from './Panel.styles';
export var getFluentStyleOverrides = {
    Panel: { styles: getPanelStyles }
};
//# sourceMappingURL=FluentStyleOverrides.js.map